import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'

import { pageChanged } from '../../../../../data/redux/page_details/actions'
import * as conversionActions from '../../../../../data/redux/conversion_details/actions'

import { APP_PAGES } from '../../../../../data/config/constants'

import CardContainer from '../../../components/cardcontainer'
import Funnel from '../../../components/charts/funnel'
import CustomHeader from '../../../../../components/customheader'
import ErrorBoundary from '../../../../../components/errorboundary'

const Conversions = ({
  screen_type,
  screen_height,
  conversion_details,
  actions
}) => {
  const { pageChanged, getFunnelAnalyticsData, updateConversionState } = actions
  const {
    funnel_data,
    top_conversion_drivers,
    filters,
    funnel_data_loading,
    funnel_data_load_error
  } = conversion_details

  useEffect(() => {
    pageChanged(APP_PAGES.CONVERSIONS, APP_PAGES.ANALYTICS)
  }, [pageChanged])

  useEffect(() => {
    getFunnelAnalyticsData(filters)
  }, [getFunnelAnalyticsData, filters])

  const onChangeDateRange = date_range => {
    const filters = {
      startDate: date_range[0],
      endDate: date_range[1]
    }
    updateConversionState({ filters })
  }

  const renderFunnelGraph = () => {
    const custom_header_props = {
      title: "Sales Funnel Analytics"
    }
    const chart_props = {
      forceFit: true,
      padding: (screen_type === 'xs' || screen_type === 'sm') ? [10, 75, 50, 0] : (screen_type === 'md' ? [10, 100, 50, 10] : [20, 280, 50, 250]),
      height: screen_height > 742 ? 742 : (screen_height > 450 ? 542 : 450),
    }
    return (
      <CardContainer
        card_container_class="ori-animated ori-fade-in ori-box-shadow-light ori-tb-mrgn-10 ori-bg-white ori-lr-pad-15 ori-b-pad-10"
        custom_header_props={custom_header_props}
        container_height={450}
        load_error={funnel_data_load_error}
        loading={funnel_data_loading}
        emtpy_condition={funnel_data.length === 0}
        show_custom_header
      >
        <Funnel
          data={funnel_data}
          action_key='action'
          count_key='count'
          count_label='Customers'
          percent_key='Percentage'
          chart_props={chart_props}
        />
      </CardContainer >
    )
  }

  const renderTopConversionDrivers = () => {
    const custom_header_props = {
      title: "Top conversion drivers",
    }
    return (
      <CardContainer
        card_container_class="ori-animated ori-fade-in ori-box-shadow-light ori-tb-mrgn-10 ori-bg-white ori-lr-pad-15 ori-b-pad-10"
        custom_header_props={custom_header_props}
        container_height={450}
        load_error={funnel_data_load_error}
        loading={funnel_data_loading}
        emtpy_condition={top_conversion_drivers.length === 0}
        show_custom_header
      >
        <Row gutter={10}>
          {
            top_conversion_drivers.map((item, index) => {
              return (
                <ErrorBoundary key={index}>
                  <Col xs={24} md={12} lg={8}>
                    <div className="ori-flex-row ori-flex-wrap ori-pad-10 ori-b-mrgn-10 ori-bg-default">
                      <div
                        className="ori-flex-column ori-flex-jc ori-capitalize ori-overflow-hidden ori-r-pad-5"
                        style={{ width: '40%' }}
                      >
                        <span className="ori-text-overflow-dotted">{item.event}</span>
                      </div>
                      <div
                        className="ori-flex-column ori-flex-jc  ori-font-bold ori-font-md ori-lr-pad-5 ori-text-center"
                        style={{ width: '40%' }}
                      >
                        {item.count}
                      </div>
                      <div
                        className="ori-font-bold ori-font-lg ori-l-pad-5 ori-text-right"
                        style={{ width: '20%' }}
                      >
                        {item.Percentage}
                      </div>
                    </div>
                  </Col>
                </ErrorBoundary>
              )
            })
          }
        </Row>
      </CardContainer>
    )
  }

  return (
    <div className="ori-lr-pad-10">
      <CustomHeader
        title="Conversions"
        date_range={[filters.startDate, filters.endDate]}
        onChangeDateRange={onChangeDateRange}
        date_range_disabled={funnel_data_loading}
        bottom_bordered
        show_date_range
      />
      {renderFunnelGraph()}
      {renderTopConversionDrivers()}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    conversion_details: state.conversion_details,
    screen_type: state.page_details.device_data.screen_type,
    screen_height: state.page_details.device_data.screen_height
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged }, conversionActions), dispatch),
  }
}

Conversions.propTypes = {
  conversion_details: PropTypes.object,
  actions: PropTypes.object,
  screen_type: PropTypes.string,
  screen_height: PropTypes.number
}

export default connect(mapStateToProps, mapDispatchToProps)(Conversions)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/conversions/index.js